// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 792 ? "main" : chunkId) + ".bundle." + __webpack_require__.h() + ".js";
};